import React from 'react';
import { getIn } from 'formik';
import Input from '@/components/shared/Input';
import { IMultiStepSignupValues } from './types';
import { UserRole } from '@/types';
import { isEmailRegistered } from '@/api/users'; // Импортируем новую функцию API
import './MultiStepSignupStep1.scss';

const baseClass = 'MultiStepSignupStep1';

interface Props {
  userRole: UserRole;
  values: IMultiStepSignupValues;
  errors: any;
  touched: any;
  handleChange: (e: React.ChangeEvent<any>) => void;
  handleBlur: (e: React.FocusEvent<any>) => void;
  setFieldValue: (field: string, value: any) => void;
  setFieldError: (field: string, message: string | undefined) => void; // Добавляем setFieldError
}

const MultiStepSignupStep1: React.FC<Props> = ({
                                                 userRole,
                                                 values,
                                                 errors,
                                                 touched,
                                                 handleChange,
                                                 handleBlur,
                                                 setFieldValue,
                                                 setFieldError, // Деструктурируем setFieldError
                                               }) => {

  const handleEmailBlur = async (e: React.FocusEvent<any>) => {
    handleBlur(e); // Вызываем оригинальный обработчик onBlur
    const email = e.target.value;

    if (email) {
      try {
        const response = await isEmailRegistered(email);
        // Исправлено: проверяем свойство isRegistered в объекте ответа
        if (response.data.isRegistered) {
          setFieldError('email', 'This email is already registered.');
        } else {
          setFieldError('email', undefined); // Очищаем ошибку, если email свободен
        }
      } catch (error) {
        console.error('Error checking email registration:', error);
        // Можно добавить обработку ошибок сети или сервера, если необходимо
      }
    }
  };

  return (
    <div className={baseClass}>
      <div className={`${baseClass}__header`}>
        <h2 className={`${baseClass}__title`}>Personal Information</h2>

      </div>

      <div className={`${baseClass}__form-group`}>
        {/* Role Selection */}
        <div className={`${baseClass}__role-selection`}>
          <label className={`${baseClass}__radio-option`}>
            <input
              type="radio"
              name="role"
              value={UserRole.OWNER}
              checked={values.role === UserRole.OWNER}
              onChange={() => setFieldValue('role', UserRole.OWNER)}
              className={`${baseClass}__radio-input`}
            />
            <span className={`${baseClass}__radio-label`}>
              Property owner
            </span>
          </label>

          <label className={`${baseClass}__radio-option`}>
            <input
              type="radio"
              name="role"
              value={UserRole.MANAGER}
              checked={values.role === UserRole.MANAGER}
              onChange={() => setFieldValue('role', UserRole.MANAGER)}
              className={`${baseClass}__radio-input`}
            />
            <span className={`${baseClass}__radio-label`}>
              Property management company
            </span>
          </label>
        </div>
        {getIn(errors, 'role') && getIn(touched, 'role') && (
          <div className={`${baseClass}__field-error`}>
            {getIn(errors, 'role')}
          </div>
        )}

        {/* First Name */}
        <Input
          floatLabel
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.firstname}
          name="firstname"
          type="text"
          label="First name"
          errors={
            getIn(errors, 'firstname') && getIn(touched, 'firstname')
              ? getIn(errors, 'firstname')
              : ''
          }
        />

        {/* Last Name */}
        <Input
          floatLabel
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.lastname}
          name="lastname"
          type="text"
          label="Last name"
          errors={
            getIn(errors, 'lastname') && getIn(touched, 'lastname')
              ? getIn(errors, 'lastname')
              : ''
          }
        />

        {/* Email */}
        <Input
          floatLabel
          onChange={handleChange}
          onBlur={handleEmailBlur} // Используем новый обработчик
          value={values.email}
          name="email"
          type="email"
          label="E-mail"
          errors={
            getIn(errors, 'email') && getIn(touched, 'email')
              ? getIn(errors, 'email')
              : ''
          }
        />

        {/* Password */}
        <Input
          floatLabel
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.password}
          name="password"
          type="password"
          label="Password"
          errors={
            getIn(errors, 'password') && getIn(touched, 'password')
              ? getIn(errors, 'password')
              : ''
          }
        />

        {/* Confirm Password */}
        <Input
          floatLabel
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.confirmPassword}
          name="confirmPassword"
          type="password"
          label="Confirm password"
          errors={
            getIn(errors, 'confirmPassword') && getIn(touched, 'confirmPassword')
              ? getIn(errors, 'confirmPassword')
              : ''
          }
        />
      </div>
    </div>
  );
};

export default MultiStepSignupStep1;